<template>
	<div id="login">            
            <hr class="path ml-5 hide-on-mobile">
            <ValidationObserver tag="form" v-slot="{ invalid }" class="m-center mx-auto w-m-80 w-30" onsubmit="return false;">
                <img src="img/group-2@3x.png" alt="Bisa Cek" class="group-2 mx-auto d-block mb-5 img-fluid">
                Lupa kata sandi? Masukkan email login anda dibawah ini.
                Kami akan mengirimkan pesan email beserta link untuk 
                reset kata sandi Anda
                
                <ValidationProvider name="email" rules="required|email">
                    <div class="form-group mt-4" slot-scope="{ errors }">
                        <label class="form-label">Email</label>
                        <input type="email" v-model="email" class="form-control" :class="{ 'error': errors[0] || authFalse }" placeholder="Masukkan email">
                        <div class="error-alert">{{ errors[0] }}</div>      
                    </div>
                </ValidationProvider>

                <button :disabled="invalid" @click="resetPassword" class="mt-4 btn btn-primary w-full pd-10-20">Reset Kata Sandi</button>
            </ValidationObserver>           
        </div>
</template>

<script>
export default {
	name: 'ForgotPassword',
    data() {
        return {
            email: null,
            authFalse: false
        }
    },
    methods: {
        resetPassword() {
            let _ = this
            _.axios.post('/auth/forgot_password', { email: _.email })
                .then(resp=>{
                    if ( resp.data ) {
                        _.$router.push('lupa-password-confirm')
                    }
                    
                })
                .catch(err=>{
                    console.log(err.message)
                    _.authFalse = true
                })
        }
    }
}
</script>